import { Box, Stack, Typography } from "@mui/material"
import { FC } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import { Navigate } from "react-router"
import logo from "../../assets/mobilus-logo.png"
import LoadingPage from "./LoadingPage"
import LoginButton from "./LoginButton"
import { pathConstants } from "src/features/shared-module/constants"

export const PublicHomePage: FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()

  if (isLoading) {
    return <LoadingPage />
  }
  if (isAuthenticated) {
    return <Navigate to={pathConstants.defaultRoute} replace />
  }

  return (
    <Box
      data-testid="public-home-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: 2,
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(145deg, #F7FAFA 0%, #E8F6F8 40%, #EEF3F4 100%)",
      }}
    >
      {/* Decorative background elements */}
      <Box
        sx={{
          position: "absolute",
          top: -120,
          right: -120,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(11,114,133,0.06) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -80,
          left: -80,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(240,140,106,0.08) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {/* Content card */}
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 1,
          px: 6,
          py: 5,
          borderRadius: 4,
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(16px) saturate(180%)",
          WebkitBackdropFilter: "blur(16px) saturate(180%)",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: "0 8px 32px rgba(11, 114, 133, 0.08)",
          maxWidth: 420,
          width: "100%",
        })}
      >
        <img
          src={logo}
          alt="Mobilus Logo"
          data-testid="public-home-logo"
          style={{ height: 36, width: "auto" }}
        />
        <Typography
          variant="h1"
          component="div"
          sx={(theme) => ({
            mt: 3,
            mb: 1,
            fontSize: "1.75rem",
            fontWeight: 800,
            background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          })}
        >
          Dispatch
        </Typography>
        <Typography
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            mb: 4,
            textAlign: "center",
          })}
        >
          Powered by Mobilus Technologies inc.
        </Typography>
        {new URLSearchParams(window.location.search).get("reason") === "unauthorized" && (
          <Typography variant="body2" color="error" sx={{ mb: 2, textAlign: "center" }}>
            Your account does not have access to this application. Please log in with a different account.
          </Typography>
        )}
        <Stack direction="column" spacing={2} alignItems={"center"} width="100%">
          <LoginButton />
        </Stack>
      </Box>
    </Box>
  )
}
